import { WORKFLOW_EXECUTION_NOTIFICATION_PREFIX } from '../constants/workflows-execution';
import { useNotificationsStore } from 'vince-core/stores/notificationsStore';
import { type BackendNotification, type NotificationAction, NotificationActionType } from 'vince-core/types/notifications';

export default defineNuxtPlugin(() => {
    const { addHandler, addNotificationComponent } = useNotificationsStore();

    addNotificationComponent(
        'WorkflowExecutionNotification',
        defineAsyncComponent(() => import('../components/WorkflowExecutionNotification.vue'))
    );

    addHandler(WORKFLOW_EXECUTION_NOTIFICATION_PREFIX, (notification: BackendNotification): (NotificationAction | undefined) => {
        return {
            actionType: NotificationActionType.ADD_NOTIFICATION,
            payload: {
                notification: {
                    eventName: notification.eventName,
                    timestamp: notification.time,
                    keys: notification.keys,
                    data: notification.data,
                    componentName: 'WorkflowExecutionNotification'
                }
            }
        };
    });
});
